import { useRef } from "react";
import { video } from "shared/types/Report";
import useView from "./useView";
import useStorage from "shared/hooks/useStorage";

const useVideoView = (list:video[], setList:React.Dispatch<React.SetStateAction<video[]>>, path:string) => {
    const {uploadStorage, deleteStorage} = useStorage();
    const baseHook = useView(list, setList, path);
    const videoInputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const nonAudioVideoInputRefs = useRef<Array<HTMLInputElement | null>>([]);

    const onAddClickHandler = () => {
        setList(prev => [...prev, {
            id:prev.length ? prev[prev.length -1].id + 1 : 1,
            title:"",
            video:"",
            example:"",
            video_non_audio:"",
            read_only:false,
        }])
    }

    const onVideoInputClickHandler = (index: number, audio:boolean) => {
        const inputElement = audio ? videoInputRefs.current[index] : nonAudioVideoInputRefs.current[index];
        if (inputElement) {
          inputElement.click();
        } else {
          console.error(`Input element at index ${index} is null`);
        }
    };

    const onVideoChangeHandler = async (index: number, event: React.ChangeEvent<HTMLInputElement>, audio:boolean) => {
        const file = event.target.files?.[0];
        if (file) {
            try {
                const fileURL = URL.createObjectURL(file);
                updateItemVideo(index, fileURL, file, audio);
            } catch (error) {
                console.error('Error encoding video:', error);
            }
        }
    };

    const onSelectReadOnlyClickHandler = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const {checked} = event.target;
        const newList = list.map((item, idx) => {
            if (idx === index) {
                return { ...item, read_only:checked};
            }
            return item;
        });
        setList(newList);
    }

    const updateItemVideo = (index: number, videoUrl: string, file:File, audio:boolean) => {
        const newList = list.map((item, idx) => {
            if (idx === index) {
                if(audio){
                    return { ...item, video_preview: videoUrl, video:file};
                }
                return { ...item, video_non_audio_preview: videoUrl, video_non_audio:file};
            }
            return item;
        });
        setList(newList);
        baseHook.setShowProgress(false);
    };

    const onRegisterReportClickHandler = async() => {
        let data = await registerImage();
        data = baseHook.removeKeyFromObjects(data, "video_non_audio_preview");
        const register_data = baseHook.removeKeyFromObjects(data, "video_preview");
        baseHook.onRegisterReportClick("video", register_data);
    }

    const registerImage = async() => {
        let videoList = list;
        baseHook.setShowProgress(true);
        for(let i = 0; i < list.length; i++){
            const video = list[i].video;
            const non_audio_video = list[i].video_non_audio;
            if (video instanceof File) {
                baseHook.setUploadFileName(video.name);
                const video_url = await uploadStorage(path + "/video", video, baseHook.setProgress, "video/mp4").then(res => {
                    return res || "";
                })
                videoList[i].video = video_url;
            }
            if(non_audio_video instanceof File){
                baseHook.setUploadFileName(non_audio_video.name);
                const non_audio_video_url = await uploadStorage(path + "/video", non_audio_video, baseHook.setProgress).then(res => {
                    return res || "";
                })
                videoList[i].video_non_audio = non_audio_video_url;
            }
        }
        baseHook.setShowProgress(false);
        return videoList;
    }

    const onDeleteVideoClickHandler = () => {
        const newList = list.map((item, idx) => {
            if (idx === baseHook.selectedFile.index) {
                if(baseHook.selectedFile.audio){
                    return { ...item, video:null, video_preview:""};
                }else{
                    return { ...item, video_non_audio:null, video_non_audio_preview:""};
                }
            } 
            return item;
        });
        if(baseHook.selectedFile.url.includes("https")){
            deleteStorage(path + "/video", baseHook.selectedFile.url);
            const data = baseHook.removeKeyFromObjects(newList, "video_non_audio_preview");
            const register_data = baseHook.removeKeyFromObjects(data, "video_preview");
            baseHook.onRegisterReportClick("video", register_data);
        }
        setList(newList);
    }

    return {...baseHook, onAddClickHandler, onRegisterReportClickHandler, videoInputRefs, onVideoInputClickHandler, onVideoChangeHandler, onDeleteVideoClickHandler, onSelectReadOnlyClickHandler}
}

export default useVideoView;